import { v4 as uuidv4 } from "uuid";

export const getSessionIdFromUrl = (): string | undefined => {
	if (typeof window === "undefined") {
		return undefined;
	}

	return (
		new URLSearchParams(window.location.search).get("sessionId") || undefined
	);
};

export const createSessionId = (sessionId?: string): string => {
	return sessionId || uuidv4();
};

export const createInitialSessionId = (): string => {
	if (typeof window === "undefined") {
		return "";
	}

	return createSessionId(getSessionIdFromUrl());
};
